import { FC } from 'react';
import Link from 'next/link';

import { Membership, PaymentInstrument, PaymentInstrumentStripe } from '@bpm-web-app/supreme-api-sdk';
import { usePreviewResumeSubscription } from '@bpm-web-app/swr-hooks';
import { formatDateToString } from '@bpm-web-app/utils';
import IconCard from '../../../components/icons/payment.svg';
import { usePlatform } from '../../../helpers/usePlatform';
import accountStyles from '../../../account.module.css';
import styles from './resume-button.module.css';

type Props = {
    membership: Membership
    paymentInstrument?: PaymentInstrument
    platform: ReturnType<typeof usePlatform>
    hideUpdate?: boolean
};

export const PausedMembershipModal: FC<Props> = ({ platform, membership, paymentInstrument, hideUpdate, children }) => {
    const { data } = usePreviewResumeSubscription(platform);

    return (
        <>
            {!!children && <p className={styles['description-text']}>{children}</p>}
            <p className={styles['payment-method']}>
                <IconCard />
                {(paymentInstrument as PaymentInstrumentStripe)?.description}

                {!hideUpdate && (
                    <Link href="./payment">
                        <a>Update</a>
                    </Link>
                )}
            </p>
            <p className={styles['payment-amount']}>
                Pay Now: {data ? <>${data.pay_now}</> : <span className={accountStyles['loading-wrapper']}>$00.00</span>}
            </p>
            <p className={styles['description-text']}>
                Next payment of ${membership.subscription?.package?.amount} will be on {data ? formatDateToString(data?.renews_at, 'L') : <span className={accountStyles['loading-wrapper']}>00/00/0000</span>}, when your plan renews.
            </p>
        </>
    );
};
